import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import Antd from "ant-design-vue";
import "ant-design-vue/dist/antd.css";

import "viewerjs/dist/viewer.css";
import VueViewer from "v-viewer";

const app = createApp(App);
if (process.env.NODE_ENV === "development") {
  if ("__VUE_DEVTOOLS_GLOBAL_HOOK__" in window) {
    window.__VUE_DEVTOOLS_GLOBAL_HOOK__.Vue = app;
  }
  app.config.devtools = true;
}

// setupAntd(app);
createApp(App)
  .use(store)
  .use(router)
  .use(Antd)
  .use(VueViewer)
  .mount("#app");
